import React, { useEffect, useState } from 'react';
import { Button, Form, FormFeedback, Input, Modal } from 'reactstrap';
import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

export const UModal = ({ props, setShowModal, showModal, modalHeader, modalClose, modalRespInfo, isUpdate, rowInfo }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal])

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            id: rowInfo?.id,
            revger: rowInfo?.revger? rowInfo?.revger  : '',
        },
        validationSchema: Yup.object({
          revger: Yup.string().required("Ingrese el campo REGVER"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values, active);
            resetForm();
            setShowModal(false);
            // dispatch(loginUser(values, props.history));
        }
    });

    const { className } = props;
    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () => {
        validation.resetForm()
        modalClose()
    }

    return (
        <BaseCustomModal
            title={modalHeader}
            isModalOpen={showModal}
            handleCancel={toggle}
            footer={null}
            onCancel={toggle}
            afterClose={onClosed}
            centered
            width={800}            
        >
            <GradientDecorationLine />

            <Form
                className="form-horizontal mt-3 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3 px-5">
                    <label className='text-primary'>REVGER</label>
                    <Input
                        name="revger"
                        className="form-control text-primary"
                        placeholder="REVGER"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.revger || ""}
                        invalid={
                            validation.touched.revger && validation.errors.revger ? true : false
                        }
                    />
                    {validation.touched.revger && validation.errors.revger ? (
                        <FormFeedback type="invalid">{validation.errors.revger}</FormFeedback>
                    ) : null}
                </div>
                
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            type="submit"
                            color="primary"
                            outline
                            className="me-3"
                            icon="mdi mdi-content-save"
                            label="Guardar"
                        />
                        <BaseCustomButton
                            color="danger"
                            outline
                            className="me-3"
                            icon="mdi mdi-close-circle-outline"
                            label="Cancelar"
                            onClick={toggle}
                        />
                    </div>
                </div>
            </Form>
        </BaseCustomModal>
    );
};
